module.exports = __webpack_public_path__ + "static/media/29ADMSPC32.202514b1.jpg";